module.exports = __webpack_public_path__ + "img/main_img4.3f80de15.png";